import { __decorate } from "tslib";
import { TextField as FASTTextField } from '@microsoft/fast-components';
import { observable } from '@microsoft/fast-element';
import { foundationUrlInputStyles as styles } from './url-input.styles';
import { foundationUrlInputTemplate as template } from './url-input.template';
export const foundationUrlInputShadowOptions = undefined;
export const defaultUrlInputConfig = {};
/**
 * @tagname %%prefix%%-url-input
 */
export class UrlInput extends FASTTextField {
    constructor() {
        super(...arguments);
        this.value = '';
    }
    saveUrl(url) {
        this.value = url.startsWith('http') ? url : 'https://' + url;
        this.focused = false;
    }
    focus() {
        this.focused = true;
    }
}
__decorate([
    observable
], UrlInput.prototype, "value", void 0);
__decorate([
    observable
], UrlInput.prototype, "focused", void 0);
export const foundationUrlInput = UrlInput.compose(Object.assign({ baseName: 'url-input', template,
    styles, shadowOptions: foundationUrlInputShadowOptions }, defaultUrlInputConfig));
